import React from "react";
import {driver,fuel,others,police,toll,coin} from "../../../common/svg";
import SecureImage from "../../../components/BucketImage/Image";

interface ExpenseDetail {
    label: string;
    amount: string;
    icon: string;
  }
  
  const ExpenseDetails: ExpenseDetail[] = [
    {
      label: "Fuel Expenses",
      amount: "₹ 200",
      icon: fuel,
    },
    {
      label: "Toll Expenses",
      amount: "₹ 200",
      icon: toll,
    },
    {
      label: "RTO Expenses",
      amount: "₹ 200",
      icon: police,
    },
    {
      label: "Driver Expenses",
      amount: "₹ 200",
      icon: driver,
    },
    {
      label: "Other Expenses",
      amount: "₹ 200",
      icon: others,
    },
    {
      label: "Total Expenses",
      amount: "₹ 200",
      icon: coin,
    },
  ];
  
  const ExpenseComponent: React.FC = () => {
    return (
      <div className="p-2">
        <p className="text-[16px] font-[600] leading-[30px]">Expense Details</p>
  
        <div className="grid grid-cols-2 gap-2 mt-1">
          {ExpenseDetails.map((expense, index) => (
            <div key={index} className="flex justify-between items-center p-2">
              <div className="flex items-center gap-2">
             
                  <SecureImage
              
              fileKey={expense.icon}
              alt="header icon"
              width="30px"
            />
                <div>
                  <p
                    className={`text-[14px] ${
                      expense.label === "Total Expenses" ? "text-[16px] font-[600]" : ""
                    }`}
                  >
                    {expense.label}
                  </p>
                  <p
                    className={`text-[14px] ${
                      expense.label === "Total Expenses" ? "text-[16px] font-[600]" : ""
                    }`}
                  >
                    {expense.amount}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default ExpenseComponent;
  